import '@fontsource-variable/inter';
import './styles/app.css';
import './styles/workspace.css';
import './styles/stage.css';
import {createApp, errorView} from './app';
import {readRoute} from './core/routing';
import {registerBuiltinThemes} from './themes';
import {siteTransition} from './ui/site-transition';

registerBuiltinThemes();

const root = document.querySelector<HTMLElement>('#app');

async function start() {
  if (!root) return;
  if (await siteTransition()) return;
  try {
    root.replaceChildren(await createApp(readRoute()));
  } catch (error) {
    root.replaceChildren(errorView(error));
  }
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    void navigator.serviceWorker.register('/service-worker.js');
  }
}

void start();
